import { LSL_CLIENT_ID } from 'config/constants';
import { LSL_AUTH_API_URL, ROUTER_BASENAME, SELF_SERVICE_AUTH_REDIRECT_BASE_URL } from 'config';

const getLoginUrl = (state: string, noPrompt?: boolean) => {
  const encodedState = encodeURIComponent(state);

  return `${LSL_AUTH_API_URL}?response_type=code&client_id=${LSL_CLIENT_ID}&scope=profile&redirect_uri=${SELF_SERVICE_AUTH_REDIRECT_BASE_URL}${ROUTER_BASENAME}/auth&web=true&state=${encodedState}${
    noPrompt ? '&prompt=none' : ''
  }`;
};

export default getLoginUrl;
